import { render, staticRenderFns } from "./Consultant.vue?vue&type=template&id=6f3a66a4&scoped=true&lang=pug&"
import script from "./Consultant.vue?vue&type=script&lang=ts&"
export * from "./Consultant.vue?vue&type=script&lang=ts&"
import style0 from "./Consultant.vue?vue&type=style&index=0&id=6f3a66a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a66a4",
  null
  
)

export default component.exports